// extracted by mini-css-extract-plugin
module.exports = {"meetingStatusWrapper":"MeetingStatus_meetingStatusWrapper__1dfHK","borderY":"MeetingStatus_borderY__3c14D"};